import React from 'react'
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';

export const DialogModal = ({config}) => {

    return (
        <Dialog
            maxWidth="xs"
            aria-labelledby="confirmation-dialog-title"
            open={config.show}
            style={{zIndex: 13000}}
        >
            <DialogTitle id="confirmation-dialog-title">{config.title}</DialogTitle>
            <DialogContent dividers>
                {config.text}
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={() => config.onAccept()} color="primary">Sí</Button>
                <Button onClick={() => config.onCancel()} color="primary">No</Button>
            </DialogActions>
        </Dialog>
    );
}